<template>
  <v-container fluid grid-list-lg>
    <v-layout column wrap class="pt-1">
      <v-toolbar color="primary dark-2" dark tabs>
        <v-btn v-if="tipo != 1" :loading="load" icon @click="fechar()">
          <v-icon>save_alt</v-icon>
        </v-btn>
        <v-text-field v-model="codigo" class="mx-3 pt-4 mt-4" label="Buscar" prepend-inner-icon="search" outlined
          :disabled="load" :error-messages="msg" @input="buscarSenhas" />
      </v-toolbar>

      <div>
        <v-card v-if="senhas.length > 0" class="elevation-3">
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(senha, index) in senhas" :key="index">
              <v-expansion-panel-header>
                <v-row no-gutters class="align-center">
                  <v-col cols="1">
                    <div class="text-caption font-weight-bold">Senha</div>
                    <div><strong>{{ senha.codigo }}</strong></div>
                  </v-col>

                  <v-col cols="1">
                    <div class="text-caption font-weight-bold">OS</div>
                    <div>{{ senha.idOrdemServico }}</div>
                  </v-col>

                  <v-col cols="3">
                    <div class="text-caption font-weight-bold">Paciente</div>
                    <div>{{ senha.nomePaciente }}</div>
                  </v-col>

                  <v-col cols="2">
                    <div class="text-caption font-weight-bold">Contato</div>
                    <div>{{ senha.numeroPaciente }}</div>
                  </v-col>

                  <v-col cols="2">
                    <div class="text-caption font-weight-bold">Status</div>
                    <v-chip :color="getStatusColor(senha.status)" small dark>
                      {{ senha.status }}
                    </v-chip>
                  </v-col>

                  <v-col cols="3">
                    <div class="text-caption font-weight-bold">Chegada</div>
                    <div>{{ formatDate(senha.dataChegada) }}</div>
                  </v-col>

                </v-row>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="6">
                        <v-card outlined>
                          <v-card-title class="subtitle-1">
                            <v-icon left>mdi-calendar-clock</v-icon>
                            Detalhes do Atendimento
                          </v-card-title>
                          <v-divider></v-divider>
                          <v-list dense>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Início do Atendimento</v-list-item-title>
                                <v-list-item-subtitle>{{ formatDate(senha.dataInicioAtendimento)
                                  }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Final do Atendimento</v-list-item-title>
                                <v-list-item-subtitle>{{ formatDate(senha.dataFinalAtendimento)
                                  }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Recepcionista</v-list-item-title>
                                <v-list-item-subtitle>{{ senha.nomeRecepcionista || 'Não informado'
                                  }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Prioridade</v-list-item-title>
                                <v-list-item-subtitle>{{ senha.prioridade || 'Normal' }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-col>
                      <v-col cols="6">
                        <v-card outlined>
                          <v-card-title class="subtitle-1">
                            <v-icon left>mdi-medical-bag</v-icon>
                            Exames Solicitados
                          </v-card-title>
                          <v-divider></v-divider>
                          <v-list v-if="senha.especialidades" dense>
                            <v-subheader>Especialidade(s)</v-subheader>

                            <v-list-item>
                              <v-list-item-icon>
                                <v-icon color="grey">topic</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{ senha.especialidades }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <v-alert v-else type="info" class="ma-4" dense outlined>
                            Nenhuma especialidade encontrada para esta senha
                          </v-alert>
                          <v-divider></v-divider>

                          <v-list v-if="senha.listaExames" dense>
                            <v-subheader>Exame(s)</v-subheader>

                            <v-list-item>
                              <v-list-item-icon>
                                <v-icon color="primary">mdi-file-document</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{ senha.listaExames }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <v-alert v-else type="info" class="ma-4" dense outlined>
                            Nenhum exame encontrado para esta senha
                          </v-alert>

                          <!-- <v-list v-if="senha.listaExames && senha.listaExames.length" dense>
                            <v-list-item
                              v-for="(exame, exIndex) in senha.listaExames"
                              :key="exIndex"
                            >
                              <v-list-item-icon>
                                <v-icon color="primary">mdi-file-document</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{ exame }}</v-list-item-title>
                                <v-list-item-subtitle>
                                  {{ senha.especialidades[exIndex] }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <v-alert v-else type="info" class="ma-4" dense outlined>
                            Nenhum exame encontrado para esta senha
                          </v-alert> -->
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>

        <v-alert v-else type="info" class="mt-4">
          Nenhuma senha encontrada para os critérios selecionados
        </v-alert>
      </div>
    </v-layout>

    <v-dialog v-model="dialog" max-width="900px">
      <v-card>
        <v-card-title>
          Detalhes da senha {{ senha }}
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="6">
              <h3>Especialidades</h3>
              <v-list dense>
                <v-list-item v-for="(esp, index) in especialidades" :key="index">
                  <v-list-item-content>
                    <v-list-item-title>{{ esp }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col cols="6">
              <h3>Exames</h3>
              <v-list dense>
                <v-list-item v-for="(exame, index) in exames" :key="index">
                  <v-list-item-content>
                    <v-list-item-title>{{ exame.nome }}</v-list-item-title>
                    <v-list-item-subtitle>
                      Especialidade: {{ exame.especialidade }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>

import service from '../../services/administradorUnidade.service'
import recepcionistaService from '../../services/recepcionista.service'
import moment from 'moment'

export default {
  name: 'InfoSenhas',

  props: {
    tipo: Number
  },

  data: (vm) => ({
    tabs: null,
    idOs: null,
    msg: '',
    codigo: '',
    load: false,
    senhasAux: '',
    senhas: [],
    dialog: false,
    selectedOS: null,
    exames: [],
    especialidades: []
  }),
  watch: {
    codigo (val) {
      if (val != '') {
        console.log(val)
        let lista = []
        this.senhasAux.forEach(s => {
          if (
            s.codigo.includes(val.toUpperCase()) ||
            s.nomePaciente.includes(val.toUpperCase()) ||
            s.nomeRecepcionista.includes(val) ||
            s.status.includes(val)) {
            lista.push(s)
          }
        })
        this.senhas = lista
      } else {
        console.log('---')
        this.senhas = this.senhasAux
      }
    }
  },
  mounted () {
    this.carregarDados()
  },

  created () {
    console.log('created...')
  },

  methods: {
    getStatusColor (status) {
      const cores = {
        pendente: 'orange',
        pendenteCancelado: 'red',
        chamando: 'blue',
        chamandoCancelado: 'red',
        chamandoPaciente: 'blue',
        chamandoPacienteCancelado: 'red',
        emAtendimento: 'purple',
        emAtendimentoCancelado: 'red',
        emAtendimentoAtendente: 'purple',
        emAtendimentoAtendenteCancelado: 'red',
        atendimentoEmEspera: 'orange',
        atendimentoEmEsperaCancelado: 'red',
        atendimentoTransferido: 'teal',
        atendimentoTransferidoCancelado: 'red',
        atendido: 'green',
        atendidoCancelado: 'red',
        naoAtendido: 'grey',
        naoAtendidoCancelado: 'red',
        consultado: 'green',
        naoConsultado: 'grey',
        cancelado: 'red'
      }

      return cores[status] || 'grey'
    },
    abrirDialog (senha) {
      this.exames = senha.listaExames
      this.especialidades = senha.especialidades
      this.selectedOS = { id: senha.idOrdemServico }
      this.dialog = true
    },
    fechar () {
      this.$emit('fechar')
    },
    mapearLetraPrioridade (prioridade) {
      if (prioridade === 0) {
        return 'C'
      } else if (prioridade === 1) {
        return 'P'
      } else if (prioridade === 2) {
        return 'B'
      } else if (prioridade === 3) {
        return 'A'
      }
    },
    formatPrioridade (p) {
      var codigo = ''
      switch (p) {
        case 0:
          codigo = 'Convencional'
          break
        case 1:
          codigo = 'Idoso, Gestante, ...'
          break
        case 2:
          codigo = 'Prioridade de serviço'
          break
        case 3:
          codigo = '(Idoso, Gestante, ...) e Serviço'
          break
        case 4:
          codigo = 'Emergência'
          break
      }
      return codigo
    },
    formatStatus (s) {
      var status = ''
      switch (parseInt(s)) {
        case 0:
          status = 'Aguardando conclusão de outros exames'
          break
        case 1:
          status = 'Pronto para o atendimento'
          break
        case 2:
          status = 'Concluido'
          break
      }
      return status
    },
    formatDate (date) {
      if (date == null || date === '') {
        return ''
      } else {
        return moment(date).format('DD/MM/YYYY hh:mm:ss')
      }
    },
    carregarDados () {
      this.senhas = []
      this.load = true
      if (this.tipo === 1) {
        service.administradorUnidade.retornarInfoSenhas().then(r => {
          if (r.status == 200) {
            if (r.data.length > 0) {
              this.senhas = r.data
              this.senhas.forEach(s => {
                s.codigo = `${this.mapearLetraPrioridade(s.prioridade)}${s.codigo}`
                if (!s.nomePaciente) s.nomePaciente = ''
                if (!s.nomeRecepcionista) s.nomeRecepcionista = ''
                if (!s.status) s.status = ''
                if (!s.idOrdemServico) s.idOrdemServico = ''
              })
              this.senhasAux = this.senhas
            } else {
              this.msg = 'Nenhuma senha encontrada'
            }
          }
        }).finally(() => {
          this.load = false
        })
      } else {
        recepcionistaService.recepcionista.retornarInfoSenhas().then(r => {
          if (r.status === 200) {
            if (r.data.length > 0) {
              this.senhas = r.data
              this.senhas.forEach(s => {
                s.codigo = `${this.mapearLetraPrioridade(s.prioridade)}${s.codigo}`
                if (!s.nomePaciente) s.nomePaciente = ''
                if (!s.nomeRecepcionista) s.nomeRecepcionista = ''
                if (!s.status) s.status = ''
                if (!s.idOrdemServico) s.idOrdemServico = ''
              })
              this.senhasAux = this.senhas
            } else {
              this.msg = 'Nenhuma senha encontrada'
            }
          }
        }).finally(() => {
          this.load = false
        })
      }
    },
    onInput (val) {
      this.steps = parseInt(val)
    },
    nextStep (n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
      }
    }
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #f2f2f2
}

#thAtendimento {
  background-color: #00897b;
  color: white;
}

#thExame {
  background-color: #005b4f;
  color: white;
}
</style>
